import config from '@conf'
import get from 'lodash/get'
import divide from 'lodash/divide'

export class InvestmentTokenRecord {
  constructor (record) {
    this._record = record

    this.code = get(record, 'asset_details.code')
    this.owner = get(record, 'asset_details.owner')
    this.available = get(record, 'asset_details.available_for_issuance')
    this.name = get(record, 'asset_details.details.name')
    this.signer = get(record, 'asset_details.preissued_asset_signer')
    this.max = get(record, 'asset_details.max_issuance_amount')
    this.issued = get(record, 'asset_details.issued')
    this.policy = get(record, 'asset_details.policy')
    this.policies = this._getPolicies()
    this.terms = this._getTerms()
    this.termsUrl = this._getTermsUrl()
    this.logo = this._getLogo()
    this.logoUrl = this._getLogoUrl()
    this.tokenSale = this._getLastTokenSale()
    this.availableBalance = record.balance
    this.convertedBalance = record.converted_balance
    this.convertedAsset = record.converted_to_asset
    this.price = divide(record.converted_balance, record.balance)
    this.lockedBalance = record.locked
  }

  get logoURL () {
    const key = get(this._record, 'asset_details.details.logo.key')
    if (!key) return ''
    return `${config.FILE_STORAGE}/${key}`
  }

  _getTerms () {
    return get(this._record, 'asset_details.details.terms')
  }

  _getTermsUrl () {
    const key = get(this._record, 'asset_details.details.terms.key')
    if (!key) return ''
    return `${config.FILE_STORAGE}/${key}`
  }

  _getLogo () {
    return get(this._record, 'asset_details.details.logo')
  }

  _getLogoUrl () {
    const key = get(this._record, 'asset_details.details.logo.key')
    if (!key) return ''
    return `${config.FILE_STORAGE}/${key}`
  }

  _getPolicies () {
    const policies = get(this._record, 'asset_details.policies')
    return policies ? policies.map(policy => policy.value) : []
  }

  _getLastTokenSale () {
    const sales = get(this._record, 'asset_details.sales')
    return sales[sales.length - 1]
  }
}



// WEBPACK FOOTER //
// ./src/js/records/investment_token.record.js